/**
 * Phase 3 - Dutch translations module
 */
import enBase from './en.js';
import { translationsNl } from '../../utils/translations/translations.nl.js';
import { plansTranslationsNl } from '../../utils/translations/plans/plansTranslations.nl.js';

const merged = { ...enBase, ...translationsNl, ...plansTranslationsNl };
export default merged;
